(function () {
    const shareButton = document.querySelector('[data-copy-post-link]');
    if (!shareButton) return;

    const shareContainer = shareButton.parentElement;
    const status = shareContainer.querySelector('[data-copy-link-status]');
    const fallback = shareContainer.querySelector('[data-copy-link-fallback]');
    const articleLink = fallback.querySelector('input');

    shareButton.addEventListener('click', async function () {
        try {
            await navigator.clipboard.writeText(articleLink.value);
            fallback.hidden = true;
            status.textContent = 'Link copied';
        } catch (error) {
            fallback.hidden = false;
            status.textContent = 'Copy this address';
            articleLink.focus();
            articleLink.select();
        }
    });
})();
